import type { GraphMode } from '../../../../src/commonTypes';
import {
	MINI_TUTORIAL_DATASET_KEYS,
	miniTutorialStorageKey,
} from '../../../../src/miniTutorialPrefs';
import { setMiniTutorialHidden } from '../apiRequests';

const readLocalHideFlag = (mode: GraphMode): boolean => {
	try {
		return window.localStorage.getItem(miniTutorialStorageKey(mode)) === 'true';
	} catch {
		return false;
	}
};

export const isMiniTutorialHidden = (mode: GraphMode): boolean => {
	if (readLocalHideFlag(mode)) {
		return true;
	}
	return document.body.dataset[MINI_TUTORIAL_DATASET_KEYS[mode]] === 'true';
};

export const hideMiniTutorial = (mode: GraphMode): void => {
	try {
		window.localStorage.setItem(miniTutorialStorageKey(mode), 'true');
	} catch {
		// Private browsing can block localStorage; the account flag still persists.
	}
	document.body.dataset[MINI_TUTORIAL_DATASET_KEYS[mode]] = 'true';
	const userId = document.body.dataset.userId;
	if (userId) {
		void setMiniTutorialHidden(userId, mode);
	}
};
